// removed by extract-text-webpack-plugin
module.exports = {"bubble":"_24wg3"};


//////////////////
// WEBPACK FOOTER
// ./app/components/notification-button/notification-button.scss
// module id = 1482
// module chunks = 7